import { Tooltip } from '@zoom/components';
import classnames from 'classnames';
import React, { useRef } from 'react';
import { GetHandleProps } from 'react-compound-slider';

interface RangeSliderHandleProps {
  dataTestId?: string;
  disabled?: boolean;
  disabledMessage?: string;
  domain: number[];
  getHandleProps: GetHandleProps;
  handle: {
    id: string;
    percent: number;
    value: number;
  };
  isActive: boolean;
}

export const RangeSliderHandle: React.FC<RangeSliderHandleProps> = ({
  dataTestId,
  disabled = false,
  disabledMessage,
  domain: [min, max],
  getHandleProps,
  handle: { id, value, percent },
  isActive,
}) => {
  const ref = useRef<HTMLButtonElement>(null);

  const handleSliderProps = getHandleProps(id);

  const handleBlur = () => {
    ref?.current?.blur();
    document.removeEventListener('mouseup', handleBlur);
  };

  const SliderContent = (
    <button
      data-test-id={dataTestId}
      role="slider"
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      className={classnames('range-slider__handle__slider', {
        'range-slider__handle__slider--active': isActive,
        'range-slider__handle__slider--disabled': disabled,
      })}
      ref={ref}
      style={{
        left: `${percent}%`,
      }}
      type="button"
      {...handleSliderProps}
      onMouseDown={(e: MouseEvent) => {
        handleSliderProps.onMouseDown(e);
        document.addEventListener('mouseup', handleBlur);
      }}
    />
  );

  return disabledMessage ? (
    <Tooltip message={disabledMessage} placement="top">
      {SliderContent}
    </Tooltip>
  ) : (
    SliderContent
  );
};
